import Atc from '../../../../Lib/ATC';

import productGetProducts from './getProducts';
import productGetProductsFromCategory from './getProductsFromCategory';

export const ErrorTypes = Atc.UseCases.Types.JemisysErrorTypes.ProductErrorTypes;

export default {
    productGetProducts,
    productGetProductsFromCategory,
};
